import {
  black2,
  black3,
  bold,
  semibold,
} from '../../../assets/shared-styles/general';

const styles = {
  horizontalSeparator: {
    display: 'block',
    height: '24px',
  },
  tablesItem: {
    display: 'flex',
    flexGrow: '1',
    '&:not(:last-child)': {
      marginBottom: '16px',
    },
    '& > *': {
      width: '100%',
    },
    '& table': {
      width: '100%',
      border: 'solid 1px rgba(0, 0, 0, 0.15)',
      borderRadius: '4px',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      backgroundColor: '#fafafa',
      tableLayout: 'fixed',
      boxShadow: '0 2px 4px 0 rgba(17, 17, 17, 0.05)',
      '& thead': {
        '& th': {
          border: 'solid 1px rgba(0, 0, 0, 0.1)',
          padding: '8px 12px',
          fontSize: '13px',
          fontWeight: bold,
        },
      },
      '& tbody': {
        fontSize: '14px',
        '& td, th': {
          border: 'solid 1px rgba(0, 0, 0, 0.1)',
          padding: '8px 12px',
        },
        '& tr:not(:last-child) td': {
          borderBottom: 'solid 1px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
  tableEmptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 0',
  },
  tableEmptyStateTitle: {
    marginBottom: '8px',
    color: black2,
    fontSize: '17px',
    fontWeight: semibold,
  },
  tableEmptyStateMessage: {
    width: '560px',
    color: black3,
    fontSize: '15px',
    textAlign: 'center',
  },
};

export default styles;
